module.exports = __webpack_public_path__ + "static/media/step4.69c6ad05.svg";